import { ReactText, useEffect, useState } from 'react';
import { t } from 'utilities/TranslationUtils';
import { observer } from 'mobx-react-lite';

// components
import { AppButton } from 'components/form';
import { Select } from '@trackman/web-shared-components';

// types
import { IOrganization, UserDataAndOrganization } from 'types/models/OrganizationModels';
import {useStores} from "../../../index";
import {IRole} from "../../../types/models/Role";

export const SelectOrganizationStep = observer(
  ({
    selectedUser,
    organization,
    onChangeUserRole,
    onClickNext,
  }: {
    organization: IOrganization | null;
    selectedUser: UserDataAndOrganization | null;
    onChangeUserRole: (roleName: string) => void;
    onClickNext: () => void;
  }) => {
    if (!organization || !selectedUser) return <></>;
    
    const [userRole, setUserRole] = useState<string>(selectedUser?.roleName);
    const {roleStore} = useStores();
    const onChangeUserRoleHandler = (chosenRole: ReactText) => {
      let newRole = chosenRole as string;
      setUserRole(newRole);
      onChangeUserRole(newRole);
    };

    const roleOptions = roleStore.roles.flatMap((role) => (
      role.isPlayer || role.isUmpire
        ? [] 
        : [{
          value: role.name, label: role.name 
        }]
      ) 
    );
    const sortedRoles = roleOptions.sort((a, b) =>
      a.value.localeCompare(b.value));
    
    useEffect(() => {
      if (!selectedUser) {
        let defaultRole = "Admin";
        setUserRole(defaultRole);
        return;
      }
      setUserRole(selectedUser.roleName);
    }, [selectedUser]);

    return (
      <section>
        {selectedUser?.organization && (
          <p>
            {t('usersPage.thisUserBelongsTo')}:
            <span className='ml-2 font-weight-bold'>
              {selectedUser.organization.name} {selectedUser.organization.shortName ? `(${selectedUser.organization.shortName})` : ''}
            </span>
          </p>
        )}
        <div className='card p-3'>
          <p className='font-18'>{t('usersPage.thisUserWillBeAddedTo')}:</p>
          <p>
            {t('usersPage.organization')}:
            <span className='ml-2 font-weight-bold'>
              {organization.name} {organization.shortName ? `(${organization.shortName})` : ''}
            </span>
          </p>
          <div>
            <Select
              label={t('common.type') as string}
              width={'300px'}
              value={userRole}
              onChange={(e) => onChangeUserRoleHandler(e.target.value as ReactText)}
              selectOptions={sortedRoles}
            />
          </div>
          <AppButton
            className='position-absolute right-1rem bottom-1rem'
            variant='primary'
            disabled={!userRole}
            onClick={onClickNext}
            data-test='user-dialog-type-step-next-button'
          >
            {t('common.next')}
          </AppButton>
        </div>
      </section>
    );
  }
);

export default SelectOrganizationStep;
